import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen, PenTool, ListTodo } from 'lucide-react';
export function KitContentsSection() {
  const ebookIncludes = ['Cómo reprogramar tu mentalidad', 'Cómo trabajar hábitos que generan resultados', 'Cómo usar la manifestación de forma consciente', 'Cómo entender la inteligencia artificial', 'Cómo usar herramientas digitales para crear oportunidades'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0d0b14]" data-id="element-71">
      <div className="max-w-7xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-73">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-74">
            Todo lo que incluye tu sistema de transformación.
          </h2>
          <div className="w-24 h-1 bg-gradient-primary mx-auto rounded-full" data-id="element-75"></div>
        </motion.div>

        {/* Main Product */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-pink-500/10 to-purple-500/10 rounded-3xl p-8 sm:p-12 shadow-xl mb-12 border border-pink-500/20 backdrop-blur-sm" data-id="element-76">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-77">
            <div className="order-2 lg:order-1" data-id="element-78">
              <div className="inline-block px-4 py-1.5 rounded-full bg-pink-500/30 text-pink-200 font-bold text-sm mb-4" data-id="element-79">
                PRODUCTO PRINCIPAL
              </div>
              <h3 className="text-3xl font-bold text-white mb-2" data-id="element-80">
                Ebook principal
              </h3>
              <h4 className="text-2xl font-semibold text-pink-400 mb-6" data-id="element-81">
                "Vuelve a Brillar con IA"
              </h4>

              <p className="text-slate-300 mb-8 text-lg" data-id="element-82">
                Una guía práctica donde aprenderás cómo trabajar tu mentalidad,
                entender el poder de la manifestación y usar herramientas de
                inteligencia artificial para transformar tus ideas en
                oportunidades reales.
              </p>

              <div className="space-y-3" data-id="element-83">
                <p className="font-semibold text-slate-300 mb-4" data-id="element-84">Incluye:</p>
                {ebookIncludes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-85">
                    <CheckCircle2 className="w-6 h-6 text-pink-400 flex-shrink-0" data-id="element-86" />
                    <span className="text-slate-300" data-id="element-87">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="order-1 lg:order-2 flex justify-center relative" data-id="element-88">
              <div className="absolute inset-0 bg-pink-500/20 blur-3xl rounded-full opacity-50 -z-10" data-id="element-89"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cZN5msnqKAUtnBoigpaUb8/task_01kkt7tcn7f40b2e1bnzbyftkc_1773628381_img_1_-_Editado.png" alt="Ebook Vuelve a Brillar con IA" className="w-full max-w-md drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-90" />
            </div>
          </div>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-91">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white/[0.06] backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-white/10 flex flex-col h-full" data-id="element-92">
            <div className="inline-block px-3 py-1 rounded-full bg-purple-500/20 text-purple-300 font-bold text-xs mb-4 w-max" data-id="element-93">
              BONO 1
            </div>
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-94">
              Diario de Gratitud y Manifestación
            </h4>
            <div className="flex-grow" data-id="element-95">
              <p className="text-slate-400 mb-6" data-id="element-96">
                Un diario guiado para ayudarte a entrenar tu mente, practicar
                gratitud, reforzar tu enfoque y trabajar en la versión de ti que
                quieres construir. Incluye ejercicios diarios.
              </p>
            </div>
            <div className="mt-auto flex justify-center" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/thV81ztV1CYJJt29bB5DL3/task_01kkt73ynafbb8wwt8yseb9emj_1773627683_img_0_-_Editado.png" alt="Diario de Gratitud" className="h-48 object-contain drop-shadow-lg" data-id="element-98" />
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/[0.06] backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-white/10 flex flex-col h-full" data-id="element-99">
            <div className="inline-block px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 font-bold text-xs mb-4 w-max" data-id="element-100">
              BONO 2
            </div>
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-101">
              Guía de herramientas de Inteligencia Artificial
            </h4>
            <div className="flex-grow" data-id="element-102">
              <p className="text-slate-400 mb-6" data-id="element-103">
                Una guía práctica para descubrir herramientas que te ayudarán a
                crear contenido, organizar ideas y aprovechar la tecnología para
                avanzar más rápido.
              </p>
            </div>
            <div className="mt-auto flex justify-center" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/tHTCiPMad4LuZFsFZ2HMca/task_01kkjajhx2f8hb56yrr53ge4ce_1773362848_img_0_-_Editado.png" alt="Guía de IA" className="h-48 object-contain drop-shadow-lg" data-id="element-105" />
            </div>
          </motion.div>

          {/* Bonus 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white/[0.06] backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-white/10 flex flex-col h-full" data-id="element-106">
            <div className="inline-block px-3 py-1 rounded-full bg-pink-500/20 text-pink-300 font-bold text-xs mb-4 w-max" data-id="element-107">
              BONO 3
            </div>
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-108">
              Checklist Método Orgánico
            </h4>
            <div className="flex-grow" data-id="element-109">
              <p className="text-slate-400 mb-6" data-id="element-110">
                Un paso a paso simple para ayudarte a organizar tus acciones,
                crear presencia digital y comenzar a compartir tus ideas con el
                mundo.
              </p>
            </div>
            <div className="mt-auto flex justify-center items-center h-48 bg-pink-500/10 rounded-2xl" data-id="element-111">
              <ListTodo className="w-24 h-24 text-pink-400" data-id="element-112" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}